/**
 * :ref: https://router.vuejs.org/guide/essentials/named-routes.html
 * :ref: https://vuetifyjs.com/en/styles/scroll/#using-with-router
 */
import { ExtendedRouteConfig, RouteGroup } from '@/types/routing-types'
import CampaignCredentials from '@/pages/CampaignCredentials/index.vue'
import employeeRewardsRoutes from './employee-rewards-routes'
import franchiseMgmtRoutes from './franchise-routes'
import { generateTechTask } from '@/helpers/generated-tech-task'
import Home from '@/pages/Home/index.vue'
import integrationRoutes from './integration-routes'
import PhoneNumberManagement from '@/pages/PhoneNumberManagement/index.vue'
// import Products from '@/pages/billing/Products/index.vue'
import RemoveProduct from '@/pages/billing/RemoveProduct/index.vue'
import reportsRoutes from './reports-routes'
import socialMediaRoutes from './social-media-routes'
import techTeamRoutes from './tech-team-routes'
import twmRoutes from './twm-routes'
import UserManagement from '@/pages/UserManagement/index.vue'
import WebAppRateLimit from '@/pages/WebAppRateLimit/index.vue'


const routeGroupName: { [key in RouteGroup]: string } = {
    [RouteGroup.DEFAULT]: '',
    [RouteGroup.REPORTS]: 'Reports',
    [RouteGroup.SOCIAL_MEDIA]: 'Social Media',
    [RouteGroup.INTEGRATION]: 'Integration',
    [RouteGroup.BILLING]: 'Billing',
    [RouteGroup.TWM]: 'Two-way Messaging',
    [RouteGroup.EMP_REW]: 'Employee Rewards',
    [RouteGroup.FRANCHISE_MGMT]: 'Franchise Management',
    [RouteGroup.TECH_TEAM]: 'Stats for Nerds'
}


const routes: ExtendedRouteConfig[] = [
    {
        name: 'home',
        path: '/',
        alias: '/home',
        component: Home,
        meta: {
            title: 'Home',
            updateTitle: false,
            displayHome: false,
            displayNav: true,
            group: RouteGroup.DEFAULT
        }
    },
    {
        name: 'user-management',
        path: '/user-management',
        component: UserManagement,
        meta: {
            title: 'User Management',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.DEFAULT
        }
    },
    {
        name: 'update-webapp-app-settings',
        path: '/update-webapp-app-settings',
        component: WebAppRateLimit,
        meta: {
            title: 'Account RateLimit Settings',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.DEFAULT
        }
    },
    {
        name: 'phone-number-management',
        path: '/phone-number-management',
        component: PhoneNumberManagement,
        meta: {
            title: 'Phone Number Management',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.DEFAULT
        }
    },
    generateTechTask('Update Hubspot', 'hubspot-update-journey', RouteGroup.DEFAULT),
    generateTechTask('Account Activation', 'account-activation', RouteGroup.DEFAULT),
    {
        name: 'remove-product',
        path: '/remove-product',
        component: RemoveProduct,
        meta: {
            title: 'Remove Product',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.BILLING
        }
    },
    //    {
    //        name: 'products',
    //        path: '/products',
    //        component: Products,
    //        meta: {
    //            title: 'Add Products',
    //            updateTitle: true,
    //            displayHome: true,
    //            displayNav: true,
    //           group: RouteGroup.BILLING
    //        }
    //     },
    // generateTechTask('Change Ownership', 'change-ownership', RouteGroup.DEFAULT),
    // generateTechTask('Campaign Credentials', 'campaign-credentials', RouteGroup.DEFAULT),
    {
        name: 'campaign-credentials',
        path: '/campaign-credentials',
        component: CampaignCredentials,
        meta: {
            title: 'Campaign Credentials',
            updateTitle: true,
            displayHome: true,
            displayNav: true,
            group: RouteGroup.DEFAULT
        }
    },
    // generateTechTask('Update Username', 'update-username', RouteGroup.DEFAULT),
    ...integrationRoutes,
    ...twmRoutes,
    ...socialMediaRoutes,
    ...reportsRoutes,
    ...employeeRewardsRoutes,
    ...franchiseMgmtRoutes,
    ...techTeamRoutes
]

export { routes, routeGroupName, RouteGroup }
